export default class PriceRecurringInfo {
  public usageType: string;
  public aggregateUsage: undefined | string;
  public interval: string;
  public intervalCount: number;

  constructor(options) {
    this.usageType = options.usageType;
    this.aggregateUsage = options.aggregateUsage;
    this.interval = options.interval;
    this.intervalCount = options.intervalCount;
  }
}
